 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"actualizar":"actualizar","admin":"admin","administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados":"administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados","comisiones-vn":"comisiones-vn","administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo":"administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo","administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo":"administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo","descargar-archivo~patentamiento~recivos-efectivo":"descargar-archivo~patentamiento~recivos-efectivo","descargar-archivo":"descargar-archivo","pagos":"pagos","administracion":"administracion","cobro":"cobro","pa":"pa","calidad":"calidad","planes~stock~usados":"planes~stock~usados","planes":"planes","stock~taller~usados":"stock~taller~usados","stock":"stock","usados":"usados","patentamiento":"patentamiento","recivos-efectivo":"recivos-efectivo","postventa":"postventa","archivos":"archivos","clasificacion-compras":"clasificacion-compras","home":"home","instructivos":"instructivos","login":"login","notificaciones":"notificaciones","revendedores":"revendedores","taller":"taller"}[chunkId]||chunkId) + "." + {"actualizar":"8feaa108","admin":"01d461e1","administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados":"dc56635a","comisiones-vn":"a22e3e99","administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo":"1a0c4734","administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo":"7951bebd","descargar-archivo~patentamiento~recivos-efectivo":"4a1560d9","descargar-archivo":"c85151be","pagos":"29128279","chunk-03a6bb8a":"9d63c8b0","chunk-2d0a3556":"3387124f","chunk-2d208e29":"5ae504dc","chunk-2d2244e6":"53bb0e52","administracion":"c378bb6f","cobro":"8be22eed","pa":"126c73cf","calidad":"048c0f50","planes~stock~usados":"d41b1484","planes":"8efab55a","stock~taller~usados":"c1505c8e","stock":"e396b08d","usados":"a5327757","patentamiento":"f8a52868","recivos-efectivo":"4bdc4f65","postventa":"ac0aa714","archivos":"160f7563","chunk-70b90e06":"825b7d27","clasificacion-compras":"015c4dd5","home":"af2cc339","instructivos":"8d9812df","login":"751ebcae","notificaciones":"4d6181c7","revendedores":"d77a5fa7","taller":"8e15c23c","chunk-2d216214":"84f07ad6","chunk-2d216257":"58872a85","chunk-dd8d3c30":"f0c20501"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin":1,"chunk-03a6bb8a":1,"administracion":1,"cobro":1,"pa":1,"calidad":1,"planes~stock~usados":1,"stock":1,"usados":1,"recivos-efectivo":1,"postventa":1,"archivos":1,"chunk-70b90e06":1,"login":1,"revendedores":1,"taller":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"actualizar":"actualizar","admin":"admin","administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados":"administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados","comisiones-vn":"comisiones-vn","administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo":"administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo","administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo":"administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo","descargar-archivo~patentamiento~recivos-efectivo":"descargar-archivo~patentamiento~recivos-efectivo","descargar-archivo":"descargar-archivo","pagos":"pagos","administracion":"administracion","cobro":"cobro","pa":"pa","calidad":"calidad","planes~stock~usados":"planes~stock~usados","planes":"planes","stock~taller~usados":"stock~taller~usados","stock":"stock","usados":"usados","patentamiento":"patentamiento","recivos-efectivo":"recivos-efectivo","postventa":"postventa","archivos":"archivos","clasificacion-compras":"clasificacion-compras","home":"home","instructivos":"instructivos","login":"login","notificaciones":"notificaciones","revendedores":"revendedores","taller":"taller"}[chunkId]||chunkId) + "." + {"actualizar":"31d6cfe0","admin":"809b3ec8","administracion~calidad~cobro~comisiones-vn~pa~planes~stock~usados":"31d6cfe0","comisiones-vn":"31d6cfe0","administracion~calidad~cobro~descargar-archivo~pa~pagos~patentamiento~recivos-efectivo":"31d6cfe0","administracion~cobro~descargar-archivo~pa~patentamiento~postventa~recivos-efectivo":"31d6cfe0","descargar-archivo~patentamiento~recivos-efectivo":"31d6cfe0","descargar-archivo":"31d6cfe0","pagos":"31d6cfe0","chunk-03a6bb8a":"18becabe","chunk-2d0a3556":"31d6cfe0","chunk-2d208e29":"31d6cfe0","chunk-2d2244e6":"31d6cfe0","administracion":"c17784f0","cobro":"2e822361","pa":"0f39183d","calidad":"739d82be","planes~stock~usados":"59be8fc8","planes":"31d6cfe0","stock~taller~usados":"31d6cfe0","stock":"870f8976","usados":"885eb476","patentamiento":"31d6cfe0","recivos-efectivo":"59be8fc8","postventa":"a5f1823c","archivos":"59be8fc8","chunk-70b90e06":"0254b04d","clasificacion-compras":"31d6cfe0","home":"31d6cfe0","instructivos":"31d6cfe0","login":"97722804","notificaciones":"31d6cfe0","revendedores":"80ee12cf","taller":"7ce76f59","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-dd8d3c30":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
